import { combineReducers } from 'redux'
import { createReducer } from 'pobble-components/dist/redux-helpers'
import addGroupDialogReducer from '../dialogs/add-group/add-group.reducer'
import updateGroupDialogReducer from '../dialogs/update-group/update-group.reducer'
import setVisibilityDialogReducer from '../dialogs/set-visibility/set-visibility.reducer'

const sortDefaultState = {
  key: null,
  direction: null
}

const GroupsComponentReducer = combineReducers({
  showSelected: createReducer(false, {
    'GROUPS_COMPONENT:SHOW_SELECTED': state => true,
    'GROUPS_COMPONENT:SHOW_ALL': state => false
  }),
  addGroupDialog: addGroupDialogReducer,
  updateGroupDialog: updateGroupDialogReducer,
  setVisibilityDialog: setVisibilityDialogReducer,
  selectedGroups: createReducer(
    {},
    {
      'GROUPS_COMPONENT:SET_SELECT_STATUS': (state, { id, status }) => ({
        ...state,
        [id]: status
      }),
      'GROUPS_COMPONENT:SET_SELECT_STATUSES': (state, { statuses }) => statuses,
      'GROUPS_STORE:DELETE_REQUEST_SUCCESS': (state, { params }) => {
        const selectedGroups = { ...state }
        delete selectedGroups[params.id]
        return selectedGroups
      }
    }
  ),
  sortBy: createReducer(sortDefaultState, {
    'GROUPS_COMPONENT:SET_SORT_KEY': (state, { key, direction }) => ({
      key,
      direction
    })
  })
})

export default GroupsComponentReducer
